import React from 'react';
import { useHistory } from 'react-router-dom';

// import {
//   flattenProducts,
//   getCartVariants,
//   convertToDollars,
// } from '@nexus/fff-cart';

import Button from 'shared-components/Button/Button';
import Summary from './Summary/Summary';
// import OrderDetails from './OrderDetails/OrderDetails';
// import OrderTotal from '../Checkout/OrderTotal/OrderTotal';
import styles from './OrderConfirmation.module.css';

// OrderDetails and OrderTotal components, together with getVariants function should be re enabled
// once the API is ready to use the data about shopping credit

// const getVariants = (invoiceProducts, variantQuantities) => {
//   if (!invoiceProducts || !variantQuantities) return [];
//   const { products, variants } = flattenProducts(invoiceProducts);
//   const cartDetails = {
//     variantIds: Object.keys(variantQuantities),
//     variantQuantities,
//   };
//   const cartVariants = getCartVariants(cartDetails, variants, products);
//   return cartVariants;
// };

const OrderConfirmation = ({ firstName, lastName, shippingAddress, order }) => {
  const history = useHistory();
  const {
    id,
    total,
    purchaseCreditApplied,
    createdAt,
    // products,
    // variantQuantities,
    // subtotal,
    // shippingFee,
    // processingFee,
    // tax,
  } = order;

  const orderTotal = total - purchaseCreditApplied;
  // const cartVariants = useMemo(() => getVariants(products, variantQuantities), [
  //   order,
  // ]);

  const handleClick = () => history.push('/shop');

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h1 className={styles.pageTitle}>Order Received</h1>
        <p className={styles.thankYouNote}>
          Thank you. Your order has been received.
        </p>
      </div>
      <Summary
        firstName={firstName}
        lastName={lastName}
        shippingAddress={shippingAddress}
        orderId={id}
        orderTotal={orderTotal}
        orderDate={createdAt}
      />
      {/* <OrderDetails cartVariants={cartVariants} />
      <OrderTotal
        subtotal={subtotal}
        appliedPurchaseCredit={purchaseCreditApplied}
        hasAppliedPurchaseCredit={!!purchaseCreditApplied}
        shippingPrice={shippingFee}
        additionalShipping={processingFee}
        tax={convertToDollars(tax)}
        displayTax
        country={shippingAddress?.country}
        total={orderTotal}
      /> */}
      <div className={styles.backToShopButtonContainer}>
        <Button onClick={handleClick} className={styles.backToShopButton}>
          Back to the Shop
        </Button>
      </div>
    </div>
  );
};

export default OrderConfirmation;
